"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Variant = void 0;
var Variant;
(function (Variant) {
    Variant["ring"] = "ring";
    Variant["ringMitSteinen"] = "ringMitSteinen";
    Variant["ringMitZirkonia"] = "ringMitZirkonia";
})(Variant = exports.Variant || (exports.Variant = {}));
//# sourceMappingURL=Variant.js.map